export const MEMBER_POINT_HISTORY_BY_MEMBER_REQUEST = 'MEMBER_POINT_HISTORY_BY_MEMBER_REQUEST'
export const MEMBER_POINT_HISTORY_BY_MEMBER_SUCCESS = 'MEMBER_POINT_HISTORY_BY_MEMBER_SUCCESS'
export const MEMBER_POINT_HISTORY_BY_MEMBER_FAIL = 'MEMBER_POINT_HISTORY_BY_MEMBER_FAIL'
export const MEMBER_POINT_HISTORY_BY_MEMBER_RESET = 'MEMBER_POINT_HISTORY_BY_MEMBER_RESET'